module.exports = __webpack_public_path__ + "static/media/all_service.ca1ffb8f.svg";